import classNames from 'classnames'
import React, { ReactNode } from 'react'

// Constants
import { ALIGNMENT_TYPES } from './grid.constants'

export interface RowProps {
  children: ReactNode
  justifiedContent?: ALIGNMENT_TYPES
  className?: string
}

const Row = (props: RowProps) => {
  const className = classNames('d-flex flex-d--column', props.className, {
    [`justify-content--${props.justifiedContent}`]: !!props.justifiedContent,
  })
  return <div className={className}>{props.children}</div>
}

export default Row
